export default {"src":"/_next/static/media/union_pay_icon.5317581b.svg","height":76,"width":120,"blurWidth":0,"blurHeight":0};